<template>
    <div id="nbEdit" style="margin-top: 10px;" >
        <div v-if="isUpdataFrom" class='formDiv' style="max-height: 75vh;overflow: hidden;overflow-y: auto">
            <a-form :form="form">
                <a-row :gutter="24" v-if="dataSearch.length > 0">
                    <a-collapse v-model="activeKey" :bordered="false">
                        <a-collapse-panel
                                v-if="ii[0].sectionName != null"
                                :key="index + ''"
                                v-for="(ii, index) in newGroupSearch"
                                :header="ii[0].sectionName"
                        >
                            <a-row>
                                <a-col
                                        :span="labelSpan"
                                        v-for="(item, index) in ii"
                                        :offset="index + 1%2 ==0 ? '0': '3'"
                                        :key="index"
                                        v-if="item.disaplyable"
                                >
                                    <!--输入框-->
                                    <a-form-item
                                            class="genericFrom"
                                            v-bind="formItemLayout"
                                            :label="item.label === '' ? 'Title' : item.label"
                                    >
                                        <a-tooltip placement="bottomLeft">
                                            <template slot="title">
                                                <span>{{item.description == null ? item.label : item.description}}</span>
                                            </template>
                                            <div style="width: 100%;">
                                                <a-textarea
                                                        size="small"
                                                        v-if="item.fieldType == 'Textarea'"
                                                        :placeholder="item.label"
                                                        :rows="3"
                                                        :disabled="!item.editable"
                                                        autocomplete="off"
                                                        style="width: 100%"
                                                        v-decorator="[
                                                    item.detailUid,
                                                    {
                                                      initialValue: item.DefaultValue,
                                                      rules: [
                                                        {
                                                          required: item.mandatory,
                                                          message: $t('publicLang.Required'),
                                                          max: item.FieldLength
                                                        }
                                                      ]
                                                    }
                                                  ]"
                                                />
                                                <div  v-if="item.fieldType == 'LOOKUP'" class="relative">
                                                    <a-input
                                                            size="small"
                                                            :placeholder="item.label"
                                                            :disabled="!item.editable"
                                                            autocomplete="off"
                                                            style="width: 100%"
                                                            v-decorator="[
                                                                  item.detailUid,
                                                                  {
                                                                    initialValue: item.DefaultValue,
                                                                    rules: [
                                                                      {
                                                                        required: item.mandatory,
                                                                        message: $t('publicLang.Required'),
                                                                        max: item.fieldLength
                                                                      }
                                                                    ]
                                                                  }
                                                             ]"/>
                                                    <a-icon @click="lookupSearch(item)" type="search" class="searIputIcon" v-show="IfStatusBtn"/>
                                                </div>
                                                <a-input
                                                        size="small"
                                                        v-if="item.fieldType == 'Email'"
                                                        :placeholder="item.label"
                                                        :disabled="!item.editable"
                                                        autocomplete="off"
                                                        style="width: 100%"
                                                        v-decorator="[
                                                    item.detailUid,
                                                    {
                                                      initialValue: item.DefaultValue,
                                                      rules: [
                                                        {
                                                          type: 'email',
                                                          message: $t('publicLang.ThenotEmail'),
                                                        },
                                                        {
                                                          required: item.mandatory,

                                                          max: item.FieldLength
                                                        }
                                                      ]
                                                    }
                                                  ]"/>
                                                <a-input
                                                        size="small"
                                                        v-if="item.fieldType == 'Phone'"
                                                        :placeholder="item.label"
                                                        :disabled="!item.editable"
                                                        autocomplete="off"
                                                        style="width: 100%"
                                                        v-decorator="[
                                                item.detailUid,
                                                    {
                                                      initialValue: item.DefaultValue,
                                                      rules: [
                                                        {
                                                          required: item.mandatory,
                                                          message: $t('publicLang.PleaseMobileNumberCorrectly'),
                                                          max: item.FieldLength
                                                        }
                                                      ]
                                                    }
                                                  ]"/>
                                                <!--下拉框-->
                                                <a-select
                                                        size="small"
                                                        
                                                        v-if="item.fieldType == 'DROP'"
                                                        style="width: 100%"
                                                        allowClear
                                                        :disabled="!item.editable"
                                                        :placeholder="item.label"
                                                          show-search
                                                          optionFilterProp="label"
                                                         @search="handleSearch($event,item)"
                                                        @change="changeSelectSku"
                                                        @dropdownVisibleChange="($event) =>{$event ? handleFocus(item.FieldPattern.gmcUid, item.FieldPattern,item) : null }"
                                                        v-decorator="[
                                                    item.detailUid,
                                                    {
                                                      initialValue: item.DefaultValue == null ? undefined : item.DefaultValue,
                                                      rules: [
                                                        {
                                                          required: item.mandatory,
                                                          message: $t('publicLang.Required'),
                                                        }
                                                      ]
                                                    }
                                                  ]">
                                                    <a-select-option
                                                            v-for="(ii, index) in item.dropDownList"
                                                            :value="ii.key"
                                                            :key="index"
                                                    >{{ ii.value }}</a-select-option
                                                    >
                                                </a-select>

                                                <div v-if="item.fieldType == 'Image'">
                                                    <a
                                                            href="javascript:;"
                                                            id="fileUpload"
                                                            v-if="defaultImg == ''"
                                                    >Select a picture
                                                        <input
                                                                type="file"
                                                                accept="image/gif,image/jpeg,image/jpg,image/png"
                                                                v-on:change="fileChange($event, item)"
                                                        />
                                                    </a>
                                                    <div
                                                            v-else
                                                            style="border: 1px solid #efefef;border-radius: 3px;display: flex;align-items: center;position: relative"
                                                    >
                                                        <img
                                                                :src="defaultImg.absolutelyUrl"
                                                                width="120"
                                                                height="30"
                                                        />
                                                        <a-icon
                                                                type="close"
                                                                style="position: absolute; top: 3px;right: 3px;"
                                                                @click="deleteUpload"
                                                        />
                                                    </div>
                                                </div>
                                                <a-input
                                                        size="small"
                                                        v-if="item.fieldType == 'Integer'"
                                                        autocomplete="off"
                                                        style="width: 100%"
                                                        :disabled="!item.editable"
                                                        :placeholder="item.label"
                                                        @change="numberChangeUpdata(item)"
                                                        v-decorator="[
                                                    item.detailUid,
                                                    {
                                                      initialValue: item.DefaultValue,
                                                      rules: [
                                                        {
                                                          max: item.FieldLength,
                                                          pattern: RegExp(patt1),
                                                          required: item.mandatory,
                                                          message: $t('publicLang.RequireNumerFormat')
                                                        }
                                                      ]
                                                    }
                                                  ]">
                                                    <a-icon slot="addonAfter" type="ordered-list" size="small"
                                                    /></a-input>
                                                <a-input
                                                        size="small"
                                                        v-if="item.fieldType == 'Decimal'"
                                                        :placeholder="item.label"
                                                        autocomplete="off"
                                                        style="width: 100%"
                                                        :disabled="!item.editable"
                                                        @change="numberChangeUpdata(item, 'Decimal')"
                                                        @blur="blurDecimal(item)"
                                                        v-decorator="[
                                                    item.detailUid,
                                                    {
                                                      initialValue: item.DefaultValue == null ? undefined : item.DefaultValue,
                                                      rules: [
                                                        {
                                                          max: item.FieldLength,
                                                          pattern: RegExp(patt2),
                                                          required: item.mandatory,
                                                          message: $t('publicLang.RequireNumerFormat')
                                                        }
                                                      ]
                                                    }
                                                  ]"
                                                ><a-icon
                                                        slot="addonAfter"
                                                        type="ordered-list"
                                                        size="small"
                                                /></a-input>
                                                <a-input
                                                        size="small"
                                                        v-if="item.fieldType == 'String'"
                                                        :placeholder="item.label"
                                                        :disabled="!item.editable"
                                                        autocomplete="off"
                                                        style="width: 100%"
                                                        v-decorator="[
                                                item.detailUid,
                                                    {
                                                      initialValue: item.DefaultValue,
                                                      rules: [
                                                        {
                                                          required: item.mandatory,
                                                          message: $t('publicLang.Required'),
                                                          max: item.FieldLength
                                                        }
                                                      ]
                                                    }
                                                  ]"/>
                                                <a-input
                                                        size="small"
                                                        v-if="item.fieldType == 'Password'"
                                                        :placeholder="item.label"
                                                        :disabled="!item.editable"
                                                        autocomplete="off"
                                                        style="width: 100%"
                                                        type="password"
                                                        v-decorator="[
                              item.detailUid,
                              {
                                initialValue: item.DefaultValue,
                                rules: [
                                  {
                                    required: item.mandatory,
                                    pattern: RegExp(patt3),
                                    message: `${$t('login.passWordError1')}

                                        ${$t('login.passWordError3')}

                                        ${$t('login.passWordError4')}

                                        ${$t('login.passWordError5')}

                                        ${$t('login.passWordError6')}`,
                                    max: item.FieldLength
                                  }
                                ]
                              }
                            ]"/>
                                                <a-date-picker
                                                        @change="dateChange(item)"
                                                        size="small"
                                                        v-if="item.fieldType === 'Date'"
                                                        :placeholder="item.label"
                                                        style="width: 100%"
                                                        :disabled="!item.editable"
                                                        allowClear
                                                        format="YYYY-MM-DD"
                                                        v-decorator="[
                                                    item.detailUid,
                                                        {
                                                          initialValue:item.DefaultValue == undefined ? item.isDefType == 'Date' ? moment(new Date(), 'YYYY-MM-DD') : null : moment(item.DefaultValue, 'YYYY-MM-DD'),
                                                          rules: [
                                                            { required: item.mandatory, message: $t('publicLang.Required') }
                                                          ]
                                                        }
                                                    ]"
                                                ></a-date-picker>
                                                <a-date-picker
                                                        @change="dateChange(item)"
                                                        size="small"
                                                        v-if="item.fieldType === 'Datetime'"
                                                        :placeholder="item.label"
                                                        style="width: 100%"
                                                        allowClear
                                                        showTime
                                                        format="YYYY-MM-DD HH:mm:ss"
                                                        :disabled="!item.editable"
                                                        v-decorator="[
                                                    item.detailUid,
                                                    {

                                                      initialValue:item.DefaultValue == undefined ? item.isDefType == 'Date' ? moment(new Date(), 'YYYY-MM-DD HH:mm:ss') : null : moment(item.DefaultValue, 'YYYY-MM-DD HH:mm:ss'),
                                                      rules: [
                                                        { required: item.mandatory, message: $t('publicLang.Required') }
                                                      ]
                                                    }
                                                  ]">
                                                </a-date-picker>
                                                <a-switch
                                                        v-if="item.fieldType == 'Boolean'"
                                                        :disabled="!item.editable"
                                                        v-decorator="[
                                                    item.detailUid,
                                                    {
                                                      initialValue:
                                                        item.DefaultValue == 'true' ? true : false,
                                                      valuePropName: 'checked',
                                                      rules: [
                                                        { required: item.mandatory, message: $t('publicLang.Required') }
                                                      ]
                                                    }
                                                  ]"/>
                                            </div>
                                        </a-tooltip>
                                    </a-form-item>
                                </a-col>
                            </a-row>

                        </a-collapse-panel>
                        <a-row
                            v-for="(ii, index) in newGroupSearch"
                            v-if="ii[0].sectionName == null"
                            class="plr15"
                        >
                            <a-col
                                    v-for="(item, index) in ii"
                                    :key="index"
                                    v-if="item.disaplyable"
                                    :span="labelSpan"
                                    :offset="index + 1%2 ==0 ? '0': '3'"
                            >
                                <!--输入框-->
                                <a-form-item
                                        class="genericFrom"
                                        v-bind="formItemLayout"
                                        :label="item.label === '' ? 'Title' : item.label"
                                >
                                    <a-tooltip placement="bottomLeft">
                                        <template slot="title">
                                            <span>{{item.description == null ? item.label : item.description}}</span>
                                        </template>
                                        <div style="width: 100%;">
                                            <a-textarea
                                                    size="small"
                                                    v-if="item.fieldType == 'Textarea'"
                                                    :placeholder="item.label"
                                                    :rows="3"
                                                    :disabled="!item.editable"
                                                    autocomplete="off"
                                                    style="width: 100%"
                                                    v-decorator="[
                                                    item.detailUid,
                                                    {
                                                      initialValue: item.DefaultValue,
                                                      rules: [
                                                        {
                                                          required: item.mandatory,
                                                          message: $t('publicLang.Required'),
                                                          max: item.FieldLength
                                                        }
                                                      ]
                                                    }
                                                  ]"
                                            />
                                            <div  v-if="item.fieldType == 'LOOKUP'" class="relative">
                                                <a-input
                                                    size="small"
                                                    :placeholder="item.label"
                                                    :disabled="!item.editable"
                                                    autocomplete="off"
                                                    style="width: 100%"
                                                    v-decorator="[
                                                          item.detailUid,
                                                          {
                                                            initialValue: item.DefaultValue,
                                                            rules: [
                                                              {
                                                                required: item.mandatory,
                                                                message: $t('publicLang.Required'),
                                                                max: item.fieldLength
                                                              }
                                                            ]
                                                          }
                                                     ]"/>
                                                <a-icon @click="lookupSearch(item)" type="search" class="searIputIcon" v-show="IfStatusBtn"/>
                                            </div>
                                            <a-input
                                                size="small"
                                                v-if="item.fieldType == 'Email'"
                                                :placeholder="item.label"
                                                :disabled="!item.editable"
                                                autocomplete="off"
                                                style="width: 100%"
                                                v-decorator="[
                                                    item.detailUid,
                                                    {
                                                      initialValue: item.DefaultValue,
                                                      rules: [
                                                        {
                                                          type: 'email',
                                                          message: $t('publicLang.ThenotEmail'),
                                                        },
                                                        {
                                                          required: item.mandatory,

                                                          max: item.FieldLength
                                                        }
                                                      ]
                                                    }
                                                  ]"/>
                                            <a-input
                                                size="small"
                                                v-if="item.fieldType == 'Phone'"
                                                :placeholder="item.label"
                                                :disabled="!item.editable"
                                                autocomplete="off"
                                                style="width: 100%"
                                                v-decorator="[
                                                    item.detailUid,
                                                    {
                                                      initialValue: item.DefaultValue,
                                                      rules: [
                                                        {
                                                          required: item.mandatory,
                                                          message: $t('publicLang.PleaseMobileNumberCorrectly'),
                                                          max: item.FieldLength
                                                        }
                                                      ]
                                                    }
                                                  ]"/>
                                            <a-select
                                                size="small"
                                                showSearch
                                                v-if="item.fieldType == 'DROP'"
                                                style="width: 100%"
                                                allowClear
                                                :disabled="!item.editable"
                                                :placeholder="item.label"
                                                show-search
                                                 optionFilterProp="label"
                                                @search="handleSearch($event,item)"
                                                @change="changeSelectSku"
                                               
                                                @dropdownVisibleChange="($event) =>{$event ? handleFocus(item.FieldPattern.gmcUid, item.FieldPattern,item) : null }"
                                                v-decorator="[
                                                    item.detailUid,
                                                    {
                                                      initialValue: item.DefaultValue == null ? undefined : item.DefaultValue,
                                                      rules: [
                                                        {
                                                          required: item.mandatory,
                                                          message: $t('publicLang.Required')
                                                        }
                                                      ]
                                                    }
                                                  ]">
                                                <a-select-option
                                                        v-for="(ii, index) in item.dropDownList"
                                                        :value="ii.key"
                                                        :key="index"
                                                        :label="ii.value"
                                                >{{ ii.value }}</a-select-option
                                                >
                                            </a-select>
                                            <div v-if="item.fieldType == 'Image'">
                                                <a
                                                    href="javascript:;"
                                                    id="fileUpload"
                                                    v-if="defaultImg == ''"
                                                >{{ $t('pubGicSet.SelectPicture') }}
                                                    <input
                                                            type="file"
                                                            accept="image/gif,image/jpeg,image/jpg,image/png"
                                                            v-on:change="fileChange($event, item)"
                                                    />
                                                </a>
                                                <div v-else style="border: 1px solid #efefef;border-radius: 3px;display: flex;align-items: center;position: relative">
                                                    <img
                                                        :src="defaultImg.absolutelyUrl"
                                                        width="120"
                                                        height="30"
                                                    />
                                                    <a-icon
                                                        type="close"
                                                        style="position: absolute; top: 3px;right: 3px;"
                                                        @click="deleteUpload"/>
                                                </div>
                                            </div>
                                            <a-input
                                                size="small"
                                                v-if="item.fieldType == 'Integer'"
                                                autocomplete="off"
                                                style="width: 100%"
                                                :disabled="!item.editable"
                                                :placeholder="item.label"
                                                @change="numberChangeUpdata(item)"
                                                v-decorator="[
                                                    item.detailUid,
                                                    {
                                                      initialValue: item.DefaultValue,
                                                      rules: [
                                                        {
                                                          max: item.FieldLength,
                                                          pattern: RegExp(patt1),
                                                          required: item.mandatory,
                                                          message: $t('publicLang.RequireNumerFormat')
                                                        }
                                                      ]
                                                    }
                                                  ]">
                                                <a-icon slot="addonAfter" type="ordered-list" size="small"
                                                /></a-input>
                                            <a-input
                                                size="small"
                                                v-if="item.fieldType == 'Decimal'"
                                                :placeholder="item.label"
                                                autocomplete="off"
                                                style="width: 100%"
                                                :disabled="!item.editable"
                                                @change="numberChangeUpdata(item,'Decimal')"
                                                @blur="blurDecimal(item)"
                                                v-decorator="[
                                                    item.detailUid,
                                                    {
                                                      initialValue: item.DefaultValue,
                                                      rules: [
                                                        {
                                                            max: item.FieldLength,
                                                          pattern: RegExp(patt2),
                                                          required: item.mandatory,
                                                          message: $t('publicLang.RequireNumerFormat')
                                                        }
                                                      ]
                                                    }
                                                  ]"
                                            ><a-icon
                                                slot="addonAfter"
                                                type="ordered-list"
                                                size="small"
                                            /></a-input>
                                            <a-input
                                                size="small"
                                                v-if="item.fieldType == 'String'"
                                                :placeholder="item.label"
                                                :disabled="!item.editable"
                                                autocomplete="off"
                                                style="width: 100%"
                                                v-decorator="[
                                                    item.detailUid,
                                                    {
                                                      initialValue: item.DefaultValue,
                                                      rules: [
                                                        {
                                                          required: item.mandatory,
                                                          message: $t('publicLang.Required'),
                                                          max: item.FieldLength
                                                        }
                                                      ]
                                                    }
                                                  ]"/>
                                            <a-input
                                                    size="small"
                                                    v-if="item.fieldType == 'Password'"
                                                    :placeholder="item.label"
                                                    :disabled="!item.editable"
                                                    autocomplete="off"
                                                    style="width: 100%"
                                                    type="password"
                                                    v-decorator="[
                              item.detailUid,
                              {
                                initialValue: item.DefaultValue,
                                rules: [
                                  {
                                    required: item.mandatory,
                                    pattern: RegExp(patt3),
                                    message: `${$t('login.passWordError1')}

                                        ${$t('login.passWordError3')}

                                        ${$t('login.passWordError4')}

                                        ${$t('login.passWordError5')}

                                        ${$t('login.passWordError6')}`,
                                    max: item.FieldLength
                                  }
                                ]
                              }
                            ]"/>
                                            <a-date-picker
                                                @change="dateChange(item)"
                                                size="small"
                                                v-if="item.fieldType === 'Date'"
                                                :placeholder="item.label"
                                                style="width: 100%"
                                                :disabled="!item.editable"
                                                allowClear
                                                format="YYYY-MM-DD"
                                                v-decorator="[
                                                    item.detailUid,
                                                    {
                                                      initialValue:item.DefaultValue == undefined ? item.isDefType == 'Date' ? moment(new Date(), 'YYYY-MM-DD') : null : moment(item.DefaultValue, 'YYYY-MM-DD'),
                                                      rules: [
                                                        { required: item.mandatory, message: $t('publicLang.Required')}
                                                      ]
                                                    }
                                                  ]"
                                            ></a-date-picker>
                                            <a-date-picker
                                                    @change="dateChange(item)"
                                                    size="small"
                                                    v-if="item.fieldType === 'Datetime'"
                                                    :placeholder="item.label"
                                                    style="width: 100%"
                                                    allowClear
                                                    showTime
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    :disabled="!item.editable"
                                                    v-decorator="[
                                                        item.detailUid,
                                                        {

                                                          initialValue:item.DefaultValue == undefined ? item.isDefType == 'Date' ? moment(new Date(), 'YYYY-MM-DD HH:mm:ss') : null : moment(item.DefaultValue, 'YYYY-MM-DD HH:mm:ss'),
                                                          rules: [
                                                            { required: item.mandatory, message: $t('publicLang.Required') }
                                                          ]
                                                        }
                                                      ]">
                                            </a-date-picker>
                                            <a-switch
                                                v-if="item.fieldType == 'Boolean'"
                                                :disabled="!item.editable"
                                                v-decorator="[
                                                    item.detailUid,
                                                    {
                                                      initialValue:
                                                        item.DefaultValue == 'true' ? true : false,
                                                      valuePropName: 'checked',
                                                      rules: [
                                                        { required: item.mandatory, message: $t('publicLang.Required') }
                                                      ]
                                                    }
                                                  ]"/>
                                            <a-checkbox
                                                v-if="ifBatchUpdate"
                                                style="margin-left: 4px"
                                                v-model="item.checked"
                                                @change="changeCheckBox(item, index)"
                                            ></a-checkbox>
                                        </div>
                                    </a-tooltip>
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-collapse>
                </a-row>
            </a-form>
        </div>
        <div v-if="isbtn" class="fr mt" v-show="IfStatusBtn">
            <function-bar @handleToolClick="handleSubmit" :buttonsObj="functionBtn"></function-bar>
        </div>
        <look-up ref="lookupRefs" :lookupdata="lookupParams" v-on:propsLookupData="getPropsLookup"></look-up>
    </div>
</template>
<script>
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    import { mapState } from "vuex";
    import moment from "moment";
    import functionBar from "./functionBar.vue";
    import lookUp from "../custPage/lookup.vue";
    import cookie from "../../../api/cookie";
    export default {
        components: {
            functionBar,
            lookUp
        },
        props: {
            labelSpan: {
                type: String,
                default: function() {
                    return '8';
                }
            },
            ifBatchUpdate:{
                type: Boolean,
                default: function() {
                    return false;
                }
            },
            isbtn:{
                type: Boolean,
                default: function() {
                    return true;
                }
            },
            QueryUpdatas: '',
            headerStatus: {
                type: String,
                default: null
            },
            apiType: {
                type: String,
                default: function() {
                    return "add";
                }
            }
        },
        data() {
            return {
                transmitArr: [],
                activeKey: [], // 分组下标
                patt1: "^(0|[1-9][0-9]*|-[1-9][0-9]*)$", // 整数
                patt2: "^[0-9]+([.]{1}[0-9]+){0,1}$", // 非整数
                patt3: /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,64}$/, // 密码
                formItemLayout: {},
                dataSearch: [],
                newGroupSearch: [],
                selectData: [],
                tarGetId: "",
                functionBtn: [],

                lookupParams: {},
                isUpdataFrom: true,
                defaultImg: "",
                repeatflag: 0,
                form: this.$form.createForm(this, {onValuesChange: this.testValuesChange}),
                decimaltoFixedObj: {
                    value: {}
                },
                compareField: null,
                compareFieldMap:{},
                changVal:null
            };
        },
        computed: {
            ...mapState(["GMCUID"]),
            ...mapState(["lang"]),
            ...mapState(["isGrCombine"]),
            ...mapState(["partStatus"]),
            ...mapState(["tabsTitle"]),
            ...mapState(["systemParam"]),
            IfStatusBtn() {
                const status = this.headerStatus == null
                    ? (this.apiType === "add" ? null : (this.QueryUpdatas || {}).status)
                    : this.headerStatus;
                return !(this.QueryUpdatas || {}).notShowEditPageSaveBtn &&
                    status !== "90" && status !== "98" &&
                    (status !== "99" || (this.systemParam || {}).EDIT_CLOSE_ORDER === "Y");
            },
        },
        provide() {
            return {
                reload: this.reload
            };
        },
        watch: {
            QueryUpdatas(val) {
                this.closeClearform()

                this.$nextTick(()=>{
                    let formDiv = document.querySelector('.formDiv')
                    formDiv.scrollTop = 0;
                })
                if (val.data !== undefined) {
                    this.filterData(val);
                }
                this.changVal = null
            }
        },
        methods: {
            closeClearform(){
                this.form.resetFields();
            },
            changeCheckBox(item, index) {
                this.$forceUpdate();
            },
            pub_decimaltoFixed(params,num) {
              let newpar = parseFloat(params);
              if(isNaN(newpar)){
                return null;
              }
              if(num == null || num == undefined || num == 0){
                return newpar
              }
              return newpar.toFixed(num)
            },
            blurDecimal(item){
                if(item.digit > 0 && item.digit != undefined){
                    let obj = this.decimaltoFixedObj.value
                    let val = ''
                    let label = ''
                    for(let i in obj){
                        label = i
                        val = obj[i]
                    }
                    this.form.setFieldsValue({[label+ '']: this.pub_decimaltoFixed(val, item.digit)})
                }
            },
            addCompareField(val){// 字段配置信息
                this.transmitArr = [];
                this.compareField =  null;
                if(val.FieldPattern == null){
                    return;
                }
                let  dependOn  = val.FieldPattern.dependOn;
                let condition = val.FieldPattern.condition
                if(dependOn != null && dependOn != '' &&  condition != null && condition != ''){
                    this.compareField={} ;
                    this.compareField.dependOn = dependOn ;
                    this.compareField.condition = condition;
                    this.compareField.fieldType =  val.fieldType;
                    this.compareField.label = val.label ;
                }
                if (val.FieldPattern != null && val.FieldPattern.computeJson != null && val.FieldPattern.computeJson.configChange){
                    let data = this.dataSearch
                    let parArr = val.FieldPattern.computeJson.transmitParams
                    if(parArr.length > 0){
                        for(let ii in data){
                            if(parArr.indexOf(parseInt(data[ii].detailUid)) != -1){
                                this.transmitArr.push(data[ii])
                            }
                        }
                    }
                }
            } ,
            dateChange(val){
                this.addCompareField(val)
            },
            numberChangeUpdata(val,type){
                this.addCompareField(val)
            },
            retunFromVal(){
                return this.changVal
            },
            clearchangVal(){
                this.changVal = null
            },
            //      自动计算function
            testValuesChange(props, values){
                this.decimaltoFixedObj.value = values
                let targetAttrs = ''
                let metharr = []
                for(let oj in values){
                    targetAttrs = oj
                }

                if( this.compareField != null){
                    let gcdList =   this.QueryUpdatas.data;
                    let  condition = this.compareField.condition
                    let  dependOn = this.compareField.dependOn +'';

                    let currentGcd = null; // 当前的输入框配置
                    let otherGcd = null;     // 需要与此比较的 输入框配置

                    for(let i in gcdList ){
                        let gcdConfig = gcdList[i]
                        if( dependOn == gcdConfig.detailUid) {
                            otherGcd =  gcdConfig;
                        }else if( targetAttrs == gcdConfig.detailUid){
                            currentGcd = gcdConfig;
                        }
                    }

                    if(currentGcd != null && otherGcd != null && currentGcd.fieldType != null && currentGcd.fieldType == otherGcd.fieldType){
                        if( currentGcd.fieldType.toLowerCase()  == "datetime"  || currentGcd.fieldType.toLowerCase()  == "date"){
                            let otherGcdVal =  this.form.getFieldValue(otherGcd.detailUid) // 另字段的值
                            let currentGcdVal = values[targetAttrs];
                            if(otherGcdVal == null){
                                otherGcd.compareVal =  values[targetAttrs];   // 另个字段设置范围值
                                otherGcd.condition = condition;  // 另个字段设置判断符
                            }else{
                                if(currentGcdVal != undefined && currentGcdVal != null ){
                                    if("<" == condition  &&  currentGcdVal.diff(otherGcdVal) >= 0){
                                        console.info(condition)
                                    }else if("=" == condition &&   currentGcdVal.diff(otherGcdVal) != 0){
                                        console.info(condition)
                                    }else if(">" == condition &&   currentGcdVal.diff(otherGcdVal) <= 0){
                                        console.info(condition)
                                    }else if ("<>" == condition  &&  currentGcdVal.diff(otherGcdVal) == 0){
                                        console.info(condition)
                                    }else if (">=" == condition && currentGcdVal.diff(otherGcdVal) < 0 ){
                                        console.info(condition)
                                    }else if ("<=" == condition && currentGcdVal.diff(otherGcdVal) > 0){
                                        console.info(condition)
                                    }else{
                                        otherGcd.compareVal =  values[targetAttrs];   // 另个字段设置范围值
                                        otherGcd.condition = condition;  // 另个字段设置判断符
                                    }
                                } else{
                                    otherGcd.compareVal =  null;   // 另个字段设置范围值
                                    otherGcd.condition = condition;  // 另个字段设置判断符
                                }
                            }
                        }else{

                        }
                    }
                }

                let updateDataMap = {};   // 保存计算后的数据
                for(let i in this.transmitArr){
                    let jsArr = this.transmitArr[i].FieldPattern.computeJson
                    let computeTypeTop =  jsArr == null ? "" : jsArr.computeTypeTop
                    let arr = [];
                    for(let t in jsArr.computeMultiple){
                        // 先从 updateDataMapp 获取计算后的最新数据
                        let detailUid = jsArr.computeMultiple[t]+ '';
                        let detailValue =  updateDataMap[detailUid]
                        if(detailValue == null ||  detailValue == undefined){
                            if(parseInt(targetAttrs) == parseInt(jsArr.computeMultiple[t])){
                                detailValue = values[targetAttrs];
                            }else{
                                detailValue = this.form.getFieldValue(detailUid)
                            }
                        }
                        if ("DAY_OF_WEEK" == computeTypeTop || "DAY_OF_WEEK_BY_ZIMM_FLIGHT_GP" == computeTypeTop  || "ISO_YEAR_WEEK" == computeTypeTop  ) {
                            arr.push(detailValue);
                        }else{
                                 arr.push(parseFloat(detailValue));
                        }
                    }


                    if(arr.length > 0){
                        let flag = true
                        for(let tt in arr){
                            if(arr.length > 1 &&(arr[tt] == undefined || arr[tt] == NaN  || arr[tt] == '')){
                                flag = false
                            }
                        }

                        if(!flag){return}
                        let vl = ''
                        if(jsArr.computeTypeTop == '*'){
                            vl = 1
                            for(let cc in arr){
                                if(arr[cc] == 999){
                                    vl = ''
                                    break;
                                }
                                vl*= arr[cc]
                            }

                            if(jsArr.computeTypeNum != null){
                                if(jsArr.computeTypeBtm == '/'){
                                    vl = vl / jsArr.computeTypeNum
                                }else if(jsArr.computeTypeBtm == '*'){
                                    vl = vl * jsArr.computeTypeNum
                                }
                            }
                        }
                        else if(jsArr.computeTypeTop == '+'){
                            vl = 0
                            for(let cc in arr){
                                vl+= arr[cc]
                            }
                            if(jsArr.computeTypeNum != null){
                                if(jsArr.computeTypeBtm == '/'){
                                    vl = vl / jsArr.computeTypeNum
                                }else if(jsArr.computeTypeBtm == '*'){
                                    vl = vl * jsArr.computeTypeNum
                                }
                            }
                        }if ("DAY_OF_WEEK" == computeTypeTop || "DAY_OF_WEEK_BY_ZIMM_FLIGHT_GP" == computeTypeTop  || "ISO_YEAR_WEEK" == computeTypeTop  ){
                            vl = this.conversionValue(arr[0],computeTypeTop);
                        }


                        let id = this.transmitArr[i].detailUid
                        metharr.push({value: vl,id: id})
                        updateDataMap[id+''] = vl;
                    }
                }
                this.transmitArr = [];
//        计算后重新渲染值
                if(metharr.length > 0){
                    for(let jj in this.dataSearch){
                        for(let h in metharr){
                            if(this.dataSearch[jj].detailUid + '' == metharr[h].id){
                                let fieldType =this.dataSearch[jj].fieldType == null ? "" :this.dataSearch[jj].fieldType.toLowerCase();
                                let value = metharr[h].value;
                                if ( fieldType != 'string' && fieldType != 'text'){
                                    value = this.pub_decimaltoFixed(value, this.dataSearch[jj].digit)
                                }
                                this.dataSearch[jj].DefaultValue = value
                                const detailUid =  this.dataSearch[jj].detailUid;
                                if (this.form.getFieldValue(detailUid) !== undefined) {
                                    this.form.setFieldsValue({
                                        [detailUid]: value,
                                    });
                                }
                            }
                        }
                    }
                    this.$forceUpdate()
                }
            },
            conversionValue(value,type){
                let val = "";
                if (value == null || value == ""){
                    return null;
                }
                switch (type) {
                    case "DAY_OF_WEEK":
                        const dayOfWeek1 = value.day();
                        val = dayOfWeek1 === 0 ? 7 : dayOfWeek1;
                        break;
                    case "DAY_OF_WEEK_BY_ZIMM_FLIGHT_GP":
                        const dayOfWeek = value.day();
                        const codeVal = dayOfWeek === 0 ? 7 : dayOfWeek;
                        val = this.systemParam.ZIMM_FLIGHT_GP == null ? codeVal : this.systemParam.ZIMM_FLIGHT_GP[codeVal];

                        break;
                    case "ISO_YEAR_WEEK":
                        // 获取该日期所在的年份和ISO周数
                        const isoYear = value.isoWeekYear();  // 使用 isoWeekYear() 获取 ISO 年份
                        const isoWeek = value.isoWeek();      // 获取 ISO 周数
                        // 返回格式化的 ISO 年份-周数，如 "2023-46"
                        val = `${isoYear}-${String(isoWeek).padStart(2, '0')}`;
                        break;
                }
                return val;
            },
            deleteUpload() {
                this.defaultImg = "";
            },
            fileChange(el, item) {
                //          框架不行原生上传
                let params = JSON.stringify({});
                let file = event.target.files[0]; // 获取上传excel
                ajax.post("/generic/file", params, "img", file).then(res => {
                    if (res.code == 200) {
                        this.defaultImg = {};
                        this.defaultImg = res.data;
                        this.defaultImg.detailUid = item.detailUid;
                        this.defaultImg.absolutelyUrl = this.defaultImg.base64;
                    }
                });
            },
            moment,
            filterData(val) {
                this.defaultImg = ""; // 清空图片
                if (val === undefined) {
                    return;
                }
                let dataSearch = val.data;
                for (let ii in dataSearch) {
                    dataSearch[ii].detailUid = dataSearch[ii].detailUid + "";
                    if (dataSearch[ii].fieldType == "Image") {
                        if (dataSearch[ii].DefaultValue.name != "") {
                            this.defaultImg = {};
                            this.defaultImg.absolutelyUrl = dataSearch[ii].DefaultValue.base64;
                            this.defaultImg.fileName = dataSearch[ii].DefaultValue.name;
                            this.defaultImg.detailUid = dataSearch[ii].detailUid;
                        }
                    }
                }
                this.dataSearch = dataSearch;
                this.functionBtn = val.functionBtn;
                //                  新增分组功能
                let data = this.dataSearch;
                this.newGroupSearch = this.sortabc(data)
                let ttLength = this.newGroupSearch.length;
                for (let i = 0; i <= ttLength - 1; i++) {
                    this.activeKey.push(i + "");
                }
                if(val.zdSave && this.isGrCombine == 'true'){
                    this.$nextTick(()=>{
                        this.handleSubmit(this.functionBtn[0].children[0])
                    })
                }
            },
            sortabc(data){
                var groupabc = [];
                for(let ii in data){
                    var flag = false;
                    for(let jj in groupabc){
                        if(groupabc[jj] instanceof Array && groupabc[jj].length>0){if(groupabc[jj][0].sectionName == data[ii].sectionName){groupabc[jj].push(data[ii]);flag = true;}}
                    }
                    if(flag == false){
                        var arr = new Array();arr.push(data[ii]);
                        groupabc.push(arr);
                    }
                };
                groupabc.sort(function compare(a,b){return a[0].sectionSeq - b[0].sectionSeq;});
                return groupabc
            },
//            编辑跳转没有保存触发
            goCheckBaocun(){
                this.handleSubmit(this.functionBtn[0].children[0])
            },
            handleSubmit(item) {
                // console.log("step 11:");
                this.form.validateFields((err, values) => {
                    let filterParams = this.QueryUpdatas.data;
                    filterParams.forEach((v, i) => {
                        for (let tt in values) {
                            if (parseInt(v.detailUid) == tt) {
                                if (v.fieldType == "Date") {
                                    if (values[tt] != null) {
                                        values[tt] = values[tt].format("YYYY-MM-DD");
                                    }
                                }
                                if (v.fieldType == "Datetime") {
                                    if (values[tt] != null) {
                                        values[tt] = values[tt].format("YYYY-MM-DD HH:mm:ss");
                                    }
                                }
                            }
                        }
                    });
                    if (!err) {
                        this.changVal = null
                        let paramsData = [];
                        for (let key in values) {
                            let paramsObj = {};
                            paramsObj.key = key;
                            paramsObj.value = values[key];
                            paramsData.push(paramsObj);
                        }
                        if (this.defaultImg != "") {
                            paramsData.push({
                                key: this.defaultImg.detailUid,
                                value: this.defaultImg.fileName
                            });
                        }
                        if (item.code == "BTN_SAVE") {
                            // console.log("step 22:");
                            if (item.type == "BUTTON" && item.patternType == "INT") {
                                // console.log("step 33:");
                                if(this.QueryUpdatas.specialModule != undefined){
                                    if(this.QueryUpdatas.specialModule.length > 0){
                                        for(let ii in this.QueryUpdatas.specialModule){
                                            paramsData.push({ key: "uid", value: this.QueryUpdatas.specialModule[ii].uid });
                                        }
                                    }else{
                                        paramsData.push({ key: "uid", value: this.QueryUpdatas.uid });
                                    }
                                }else{
                                    paramsData.push({ key: "uid", value: this.QueryUpdatas.uid });
                                }
                                paramsData.push({
                                    key: "version",
                                    value: this.QueryUpdatas.version
                                });
                                let params = {};
                                if (this.apiType == "add") {
                                    params.type = "update";
                                }
                                if (this.QueryUpdatas.type == "import") {
                                    params.behrUid = this.QueryUpdatas.behrUid
                                    params.fieldMapUid = this.QueryUpdatas.fieldMapUid
                                    params.gmcUid = this.QueryUpdatas.partTableUid;
                                    params.language = this.lang;
                                    params.params = paramsData;
                                }
                                else if(this.QueryUpdatas.type == "To"){
                                    params.behrUid = this.QueryUpdatas.behrUid
                                    params.fieldMapUid = this.QueryUpdatas.fieldMapUid
                                    params.gmcUid = this.QueryUpdatas.toGmcuid
                                    params.language = this.lang;
                                    params.params = paramsData;
                                }
                                else {
                                    params.behrUid = this.QueryUpdatas.behrUid
                                    params.userUid = this.$route.query.userUid
                                    params.functionUid = this.$route.query.funcUid
                                    params.gmcUid = item.gmcUid
                                    params.params = paramsData
                                    params.language = this.lang
                                }
                                if (this.repeatflag == 0) {
                                    this.repeatflag = 1;
                                } else {
                                    return;
                                }
                                ajax.post(api.UPDATE, params).then(res => {
                                    this.repeatflag = 0;
                                    if (res.code === 200) {
                                        // console.log("step 44:");
                                        this.$emit("neibucancelModalVisible", 'init');
                                        this.$message.success(res.msg, 5);
                                        this.form.resetFields();
                                    } else {
                                        this.$customMessage.warning(res.msg, 5);
                                        // let that = this
                                        // this.$customConfirm({
                                        //     title: res.msg,
                                        //     okText: "Yes",
                                        //     okType: "danger",
                                        //     cancelText: "No",
                                        //     onOk() {
                                        //         that.$emit("neibucancelModalVisible", "init");
                                        //     }
                                        // });
                                    }
                                });
                            }
                        }
                    }else{
                        for(let i in this.dataSearch){
                            for(let e in err){
                                if(e == this.dataSearch[i].detailUid){
                                    if(values[this.dataSearch[i].detailUid]){
//                                        大于长度提示
                                        let valLen = values[this.dataSearch[i].detailUid]
                                        if(this.dataSearch[i].FieldLength < valLen.length){
                                            err[e].errors[0].message = 'Data exceeds length.'
                                        }
                                    }
                                    let v = this.dataSearch[i].label
                                    this.$customMessage.warning(v+ ' is ' + err[e].errors[0].message)
                                }
                            }
                        }
                    }
                });
            },
//            给batchUpdateShipement 条用
            batchUpdateShipement(){
                this.form.validateFields((err,values)=>{
                    let filterParams = this.QueryUpdatas.data;
                    filterParams.forEach((v, i) => {
                        for (let tt in values) {
                            if (parseInt(v.detailUid) == tt) {
                                if (v.fieldType == "Date") {
                                    if (values[tt] != null) {
                                        values[tt] = values[tt].format("YYYY-MM-DD");
                                    }
                                }
                                if (v.fieldType == "Datetime") {
                                    if (values[tt] != null) {
                                        values[tt] = values[tt].format("YYYY-MM-DD HH:mm:ss");
                                    }
                                }
                            }
                        }
                    });
                    if (!err){
                        let paramsData = [];
                        for (let key in values) {
                            let paramsObj = {};
                            paramsObj.key = key;
                            paramsObj.value = values[key];
                            paramsData.push(paramsObj);
                        }
                        if (this.defaultImg != "") {
                            paramsData.push({
                                key: this.defaultImg.detailUid,
                                value: this.defaultImg.fileName
                            });
                        }
                        this.$emit("neibucancelModalVisible", paramsData);
                    }
                })
            },
            lookupSearch(item) {
                let params = {
                    gmcUid: this.QueryUpdatas.lookupGmcuid,
                    language: this.lang,
                    feildArr: [],
                    lookup: {
                        dataUid: "",
                        gmcUid: item.FieldPattern.gmcUid,
                        ignoreCount: item.FieldPattern.ignoreCount,
                        mapUid: item.mapUid,
                        params: []
                    }
                };
                let feildArr = []
                this.form.validateFields((err, values) => {
                    let filterParams = this.dataSearch
                    filterParams.forEach((v, i) => {
                        for (let tt in values) {
                            if (parseInt(v.detailUid) == tt) {
                                if (v.fieldType == "Date") {
                                    if(values[tt] != null){
                                        values[tt] = values[tt].format("YYYY-MM-DD");
                                    }else{
                                        values[tt] = null
                                    }
                                }
                                if (v.fieldType == "Datetime") {
                                    if(values[tt] != null){
                                        values[tt] = values[tt].format("YYYY-MM-DD HH:mm:ss");
                                    }else{
                                        values[tt] = null
                                    }
                                }
                            }
                        }
                    });

                    let feildPatternParams = item.FieldPattern.params
                    for (let ii in values) {
                        for(let tt in feildPatternParams){
                            if(ii == feildPatternParams[tt]){
                                feildArr.push({key: ii,value: values[ii]})
                            }
                        }
                        if (values[ii] != null) {
                            params.lookup.params.push({ key: ii, value: values[ii] });
                        }
                    }
                });
                if (this.QueryUpdatas.lookupCode == "BTN_EDIT") {
                    params.lookup.dataUid = this.QueryUpdatas.dataUid;
                }
                if (params.gmcUid == undefined) {
                    this.$customMessage.error(this.$t('publicLang.SystemAdministrator'), 3);
                    return;
                }
                params.feildArr = feildArr
                this.lookupParams = params;
                this.$refs.lookupRefs.showModal();
            },
            handleSearch(val,item){             
                  var detailUid =  item.detailUid +'';
                 if(val){
                      this.$nextTick(()=>{
                          this.form.setFieldsValue({ [ detailUid]: val})
                          item.DefaultValue = val
                       })                                
                 }
            },
            changeSelectSku(val){
                let dataNew = this.dataSearch
                for(let ii in this.selectData){
                    if( this.selectData[ii].value == val){
                        let packageQty = this.selectData[ii].packageQty
                        for(let tt in dataNew){
                            if(packageQty != undefined){
                                if(dataNew[tt].skuxxx != undefined && dataNew[tt].skuxxx == 3){
                                    this.form.setFieldsValue({[ dataNew[tt].detailUid]: packageQty })
                                }
                            }
                        }
                    }
                }
            },
            handleFocus(id, fieldPattern,item) {
                 item.dropDownList = [];
                if(item.skuxxx !=undefined || item.skuxxx == 2){
                    if(item.FieldPattern.gmcUid != '' && item.FieldPattern.gmcUid != undefined){
                        let ppArr = [];
                        if (fieldPattern.params.length > 0) {
                            this.form.validateFields((err, val) => {
                                let params = val;
                                for (let ii in params) {
                                    if (fieldPattern.params.indexOf(parseInt(ii)) > -1) {
                                        ppArr.push({
                                            key: ii,
                                            value: params[ii]
                                        });
                                    }
                                }
                            });
                        }
                        this.tarGetId = id;
                        this.selectData = [];
                        let params = {
                            language: this.lang,
                            gmcUid: id,
                            params: ppArr
                        };

                         
                    if(item.codeGroup != undefined && item.codeGroup != null  && item.codeGroup.trim().length > 0  ){
                        params.gmcUid = this.QueryUpdatas.lookupGmcuid
                        params.codeGroup = item.codeGroup
                    }

                        ajax.post(api.GETSELECTARRAY, params).then(res => {
                            if (res.code === 200) {
                                this.selectData = res.data;
                                item.dropDownList = res.data;
                            } else {
                                this.$customMessage.warning(res.msg, 5);
                            }
                        });
                    }else{
                        let skuVal = ''
                        for(let ii in this.dataSearch){
                            if(this.dataSearch[ii].skuxxx != undefined && this.dataSearch[ii].skuxxx == 1){
                                skuVal = this.dataSearch[ii].DefaultValue
                            }
                        }
                        ajax.get(api.GENERICUOM,{sku: skuVal}).then(res=>{
                          let data =  res.data;
                          if(data == null || data.length == 0 ){
                              data = [{value: "EA", key: "EA", packageQty: 1}]
                          }
                            this.selectData = data;
                            item.dropDownList = data;

                        })
                    }
                }else{
                    let ppArr = [];
                    if (fieldPattern.params.length > 0) {
                        this.form.validateFields((err, val) => {
                            let params = val;
                            for (let ii in params) {
                                if (fieldPattern.params.indexOf(parseInt(ii)) > -1) {
                                    ppArr.push({
                                        key: ii,
                                        value: params[ii]
                                    });
                                }
                            }
                        });
                    }
                    this.tarGetId = id;
                    this.selectData = [];
                    let params = {
                        language: this.lang,
                        gmcUid: id,
                        params: ppArr
                    };

                         
                    if(item.codeGroup != undefined && item.codeGroup != null  && item.codeGroup.trim().length > 0  ){
                        params.gmcUid = this.QueryUpdatas.lookupGmcuid
                        params.codeGroup = item.codeGroup
                    }

                    ajax.post(api.GETSELECTARRAY, params).then(res => {
                       
                        if (res.code === 200) {
                            this.selectData = res.data;
                            item.dropDownList = res.data;
                        } else {
                            this.$customMessage.warning(res.msg, 5);
                        }
                    });
                }
            },
            getPropsLookup(params) {
                this.isUpdataFrom = false;
                ajax.post(api.POPUP, params).then(res => {
                    this.isUpdataFrom = true;
                    let dataSearch = res.data;
                    this.QueryUpdatas.data = dataSearch;
                    this.filterData(this.QueryUpdatas);
                });
            }
        }
    };
</script>
<style lang="less">
    .example {
          text-align: center;
          border-radius: 4px;
          padding: 30px 50px;
          margin: 50px 0;
      }

</style>
